<div class="flex flex-col lg:flex-row mt-4 ">
  <div class="border my-2 border-grey-900 rounded-lg p-4 w-full"
    [ngClass]="{'hover:border-green-400 hover:cursor-pointer':campaign.TotalSubmitted>0,'cursor-not-allowed':campaign.TotalSubmitted==0}">
    <div class="flex flex-col">
      <div class="flex justify-between w-full border-b-[1px] border-b-grey-500">
        <div class="flex items-center">
          <div class="flex flex-col md:flex-row">
            <h2 class="text-lg" [ngClass]="{'text-green-400':campaign.Active,'text-grey-900':!campaign.Active}">
              {{campaign.RequestName}}</h2>
            <h2 class="text-lg ml-1">&#64; {{campaign.Location.Description}}</h2>
          </div>

          @if (!campaign.Active) {
          <p class="ml-1 text-grey-900">(Inactive feedback campaign)</p>
          }
        </div>
        <div>
          <div class="flex flex-row">
            <div class="flex items-center ml-2"><span class="material-symbols-outlined">mail</span>
              <p class="ml-2 text-center">{{campaign.TotalSent}}</p>
            </div>
            <div class="flex items-center  ml-2"><span class="material-symbols-outlined">eyeglasses_2</span>
              <p class="ml-2 text-center">{{campaign.TotalAccessed}}</p>
            </div>
            <div class="flex items-center  ml-2"><span class="material-symbols-outlined text-green-700">check</span>
              <p class="ml-2 text-center">{{campaign.TotalSubmitted}}</p>
            </div>
            @if (campaign.TotalFailed>0) {
            <div class="flex items-center ml-2"><span class="material-symbols-outlined text-danger-base">report</span>
              <p class="ml-2 text-center">{{campaign.TotalFailed}}</p>
            </div>
            }
          </div>
        </div>
      </div>
      <div class="flex w-full mt-3 justify-between items-center">
        <div class=" flex grow flex-row justify-between">
          <div class=" flex flex-row justify-between">
            <div class="flex-col">
              <p class="text-sm text-green-400">Feedback Request</p>
              <div class="flex">
                <p>{{campaign.PublicAuditName}}</p>
                @if (campaign.OriginalAuditName!=campaign.PublicAuditName) {
                <p class="ml-1">
                  ({{campaign.OriginalAuditName}})</p>
                }
              </div>
            </div>

          </div>
          <div class="justify-between flex">
            @if (campaign.TotalMaxScore>0) {
              <div class="md:mr-8">
                <app-progress-bar [Score]="campaign.TotalScore" [MaxScore]="campaign.TotalMaxScore"></app-progress-bar>
              </div>
              
            <!--<div class="mr-8">
              <div class="relative w-24 h-24">
                <svg class="w-full h-full" viewBox="0 0 100 100">
                  <circle stroke="#ccc" stroke-width="10" cx="50" cy="50" r="40" fill="none" />
                  <circle class="progress-ring-circle stroke-green-400" stroke-width="10" stroke-linecap="round" cx="50"
                    cy="50" r="40" fill="none" stroke-dasharray="251.2" [attr.stroke-dashoffset]="strokeOffset" />
                </svg>
                <div class="absolute inset-0 flex items-center justify-center text-base font-bold">
                  {{calcProgress(campaign.TotalScore,campaign.TotalMaxScore)}}%
                </div>
              </div>
            </div>-->
            }
            @if (campaign.TotalMaxScore==0) {
            <div class="mr-8 self-center">
              @if (campaign.TotalSubmitted>0 && campaign.TotalMaxScore == 0) {
              <p class="font-bold">No Score</p>
              }
              @if (campaign.Recipients.length==0 && campaign.TotalSubmitted==0) {
              <p class="font-bold">No Responses</p>
              }
            </div>
            }
            <div class="flex flex-row justify-end pr-6 ">
              <div class=" flex justify-between">
                <div class="flex flex-col pr-2 ">
                  @if (true) {
                  <p class="text-sm text-green-400">Sent</p>
                  }
                  @if (false) {
                  <p class="text-sm text-green-400">Sending</p>
                  }
                  <p>{{humaniseDate(campaign.SendDate)}}</p>
                </div>
              </div>
              <div class=" border-l-grey-500 border-l-[1px]">
                <div class="flex flex-col  pl-2">
                  <p class="text-sm text-green-400">Expires</p>
                  <p>{{humaniseDate(campaign.ExpiryDate)}}</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>
